import { useEffect, useLayoutEffect, useRef } from "react";

import { useStores } from "#stores";
import { useLanguage } from "#structure/providers/language";
import { useAnalytics } from "#structure/providers/analytics/analytics-provider";
import { useAmplitudeBaseContext } from "#resources/hooks/use-amplitude-base-context";
import { BeamerUser, initBeamer, subscribeBeamerOpen } from "#structure/providers/beamer";

export function useBeamer() {
	const { authStore } = useStores();
	const { language } = useLanguage();
	const { sendEvent } = useAnalytics();
	const baseContext = useAmplitudeBaseContext();

	const employee = authStore.currentEmployee;
	const userId = employee?.id;
	const email = employee?.email;
	const name = employee?.name;

	useEffect(() => {
		if (!userId) return;

		const user: BeamerUser = {
			id: userId,
			email,
			name,
			language,
		};

		initBeamer(user).catch(() => {});
	}, [userId, email, name, language]);

	const trackRef = useRef({ sendEvent, baseContext });
	useLayoutEffect(() => {
		trackRef.current = { sendEvent, baseContext };
	});

	useEffect(
		() =>
			subscribeBeamerOpen(() => {
				trackRef.current.sendEvent("beamer_feed_open", trackRef.current.baseContext);
			}),
		[],
	);
}
